export default __webpack_public_path__ + "static/media/Digital KYC (2).2b006192.svg";